/**
 * normalizeSearch — diakrytyka-insensitive normalizacja stringa do filtrów
 * wyszukiwania po stronie klienta.
 *
 * Klucz dla UX z polskimi nazwami: "wisniewski" musi matchować "Wiśniewski",
 * "zolty" — "Żółty". Porównanie robi konsument (obie strony przepuszcza przez
 * ten helper i sprawdza `includes`).
 *
 * Konsumenci (jedno źródło prawdy zamiast trzech lokalnych kopii):
 * - `components/MultiSelect.tsx` (pierwowzór),
 * - `components/SearchableSelect.tsx`,
 * - `components/documents/AssignLayoutModal.tsx`.
 *
 * Ograniczenie (świadome, parytet z dotychczasowym zachowaniem): NFD nie
 * rozkłada "ł"/"Ł" (kreska nie jest znakiem składającym), więc "lodz" NIE
 * matchuje "Łódź" — ewentualna zmiana tego zachowania musi objąć wszystkich
 * konsumentów naraz (test niżej pilnuje status quo).
 */
export function normalizeSearch(s: string): string {
  return s
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase();
}
